var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heroImageCont",class:{home: _vm.headerBackground === 'home',
              clients: _vm.headerBackground === 'clients',
              cands: _vm.headerBackground === 'candidates',
              stories: _vm.headerBackground === 'stories',
              about: _vm.headerBackground === 'about',
              work: _vm.headerBackground === 'work',
              news: _vm.headerBackground === 'news',
              research: _vm.headerBackground === 'research'}},[_c('div',{staticClass:"heroInnerWrapper"},[_c('div',{staticClass:"heroInner"},[_c(_vm.headerContents,{tag:"component"})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91a67042","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/HeaderHeroImage.vue
// module id = null
// module chunks = 